import React from 'react';
import { UiStateSubscriber } from '../../controllers/ui-state-store';
import Controls from './main';
import type { OwnProps } from './types';

const ConnectedControls = (props: OwnProps) => (
	<UiStateSubscriber>
		{(state, actions) => (
			<Controls
				{...props}
				quickDateFilter={state.quickFilter}
				zoomState={state.zoomState}
				// @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: QUICK_DATE_FILTER) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [QUICK_DATE_FILTER]>'.
				setQuickDateFilter={actions.setQuickDateFilter}
				// @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: Date | null) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [Date | null]>'.
				setZoomStartDate={actions.setZoomStartDate}
				// @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: Date | null) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [Date | null]>'.
				setZoomEndDate={actions.setZoomEndDate}
			/>
		)}
	</UiStateSubscriber>
);

export default ConnectedControls;
